// extracted by mini-css-extract-plugin
export default {"root":"root___A97Qh"};